export const SEOUL_MILEAGE_TERMS_KEY = 'seoul';
